import React, { useState, ChangeEvent, KeyboardEvent, useEffect } from "react";
import { Form, Input, Tag, Button, notification } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, getMyOrganization, getReminderListRequest, updateReminder, updateReminderClear, updateReminderRequest } from "@src/redux/index";
import toast from "react-hot-toast";

interface NotificationFormProps {
  handleCancel: () => void;
  item?:any;
}

const NotificationForm: React.FC<NotificationFormProps> = ({ handleCancel ,item}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [emails, setEmails] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState<string>("");
  const dispatch = useDispatch<AppDispatch>();
  const {result:updateReminderResult,loading:updateReminderLoading} = useSelector(updateReminder)
  const { result: myOrganization } = useSelector(getMyOrganization);


  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };


  useEffect(() => {
    if (updateReminderResult?.status === "success") {
      toast.success(t("notification_toast_message"));
      dispatch(updateReminderClear());
      if (myOrganization?.id) {
        dispatch(
          getReminderListRequest({
            filter: { organizationId: myOrganization.id },
          })
        );
      } else {
        dispatch(getReminderListRequest({}));
      }
      handleCancel();
    }
  }, [updateReminderResult?.status]);

  const validateEmail = (email: string): boolean => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };

  const handleInputKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && inputValue) {
      e.preventDefault();
      const trimmed = inputValue.trim();
      if (!trimmed) {
        return;
      }
      if (!validateEmail(trimmed)) {
        form.setFields([
          { name: "emails", errors: ["Enter a valid email address"] },
        ]);
        return;
      }
      if (emails.includes(trimmed)) {
        form.setFields([
          { name: "emails", errors: ["Email already added"] },
        ]);
        return;
      }
      setEmails([...emails, trimmed]);
      setInputValue("");
      form.resetFields();
    }
  };

  const handleRemoveEmail = (emailToRemove: string) => {
    setEmails(emails.filter((email) => email !== emailToRemove));
  };

  useEffect(() => {
    setEmails(Array.isArray(item?.emails) ? item.emails : []);
  }, [item?.id]);

  

  const onFinish = (values: any) => {
    let finalEmails = [...emails];
    const trimmed = inputValue.trim();
    if (trimmed) {
      if (!validateEmail(trimmed)) {
        form.setFields([
          { name: "emails", errors: ["Enter a valid email address"] },
        ]);
        return;
      }
      if (!finalEmails.includes(trimmed)) {
        finalEmails = [...finalEmails, trimmed];
      }
    }
    if (!item?.id) {
      return;
    }
    dispatch(
      updateReminderRequest({
        id: item.id,
        data: {
          emails: finalEmails,
        },
      })
    );
  };
  
  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Form.Item
        label="Emails"
        name="emails"
        rules={[
          {
            type: "email",
            message: "Enter a valid email address",
          },
        ]}
      >
        <Input
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleInputKeyDown}
        />
      </Form.Item>
      <div className="email-tags">
        {emails.map((email, index) => (
          <Tag key={index} closable onClose={() => handleRemoveEmail(email)}>
            {email}
          </Tag>
        ))}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <Form.Item>
          <Button
            className="notification-cancel-button"
            style={{ marginRight: "10px" }}
            onClick={handleCancel}
          >
            {t("cancel")}
          </Button>
          <Button type="primary" htmlType="submit" loading={updateReminderLoading}>
            {t("set")}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default NotificationForm;
